import { render, staticRenderFns } from "./roomBasic.vue?vue&type=template&id=3a446702&scoped=true"
import script from "./roomBasic.vue?vue&type=script&lang=js"
export * from "./roomBasic.vue?vue&type=script&lang=js"
import style0 from "./roomBasic.vue?vue&type=style&index=0&id=3a446702&prod&lang=scss&scoped=true"
import style1 from "./roomBasic.vue?vue&type=style&index=1&id=3a446702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a446702",
  null
  
)

export default component.exports